module.exports = __webpack_public_path__ + "static/resume-4b2837fd1a28c7f271eed95a84e238b7.png";